import { FC } from 'react'

import { FinanceFinancialDocumentFilter } from 'generated/resources/datatable.graphql'
import {
  FinanceValueObjectsInvoiceStatusEnum,
  FinancialDocumentsCountWidgetDocument,
  FinancialDocumentsCountWidgetQuery,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import {
  FinanceWidget,
  SupportedCharts,
} from 'modules/finance/components/Widgets/common/FinanceWidget'
import { removeNullBetween } from 'modules/finance/components/Widgets/common/utils'
import { buildWidget } from 'modules/finance/components/Widgets/common/widgets'

interface QueryArgsType {
  companyId: number
  statuses?: FinanceValueObjectsInvoiceStatusEnum[]
  toDueDate?: string
}

const prepareData = (data: FinancialDocumentsCountWidgetQuery) => {
  const count = data?.finance.financialDocumentsConnection.aggregate?.count || 0

  return {
    countersChartDatas: [
      {
        label: i18n.t('finance.overview.financial_documents.total'),
        value: count,
        formattedValue: i18n.formatNumber(count),
      },
    ],
  }
}

export const buildFinancialDocumentsCountWidget = ({
  widgetTitle,
  widgetId,
  queryArgs,
  filters,
}: {
  widgetTitle?: string
  widgetId: string
  queryArgs: QueryArgsType
  filters: FinanceFinancialDocumentFilter
}) => {
  const FinancialDocumentsCountWidget: FC<{
    data: ReturnType<typeof prepareData>
  }> = ({ data }) => {
    const { countersChartDatas } = data

    return (
      <FinanceWidget
        id={`${widgetId}Dashboard`}
        type={SupportedCharts.COUNTERS}
        showChart={false}
        countersChartDatas={countersChartDatas.map((chartData) => ({
          ...chartData,
          label: widgetTitle || chartData.label,
        }))}
      />
    )
  }

  // This is to avoid problems with date filter and between provoked by the use of datatable filters
  const filteredFilters = removeNullBetween(filters)

  return buildWidget({
    id: widgetId,
    component: FinancialDocumentsCountWidget,
    document: FinancialDocumentsCountWidgetDocument,
    prepareData: (data: FinancialDocumentsCountWidgetQuery) => prepareData(data),
    queryArgs: {
      ...queryArgs,
      financialDocumentsFilters: {
        ...filteredFilters,
      },
    },
  })
}
